import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { useStyles } from '../../hooks/useStyles';
import { circularProgressIndicatorStyles, } from '../CircularProgressIndicator';
import { Base } from '../Base';
import { circularProgressIndicatorTheme } from '../CircularProgressIndicator/CircularProgressIndicator.stylex';
import { determinateCircularProgressIndicatorStyles, } from './DeterminateCircularProgressIndicator.styles';
// https://github.com/material-components/material-web/blob/main/progress/internal/progress.ts
// https://github.com/material-components/material-web/blob/main/progress/internal/circulardeterminate-progress.ts
export const DeterminateCircularProgressIndicator = createPolymorphicComponent(forwardRef(function DeterminateCircularProgressIndicator(props, forwardedRef) {
    const { styles, sx, value, withLabel, min = 0, max = 1, zeroBased, labelFormatter, disabled, children, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'CircularProgressIndicator',
        styles: [
            circularProgressIndicatorStyles,
            determinateCircularProgressIndicatorStyles,
            styles,
        ],
    });
    const value0 = zeroBased ? 0 : min;
    const pct = Math.max(Math.min((value - value0) / (max - value0), 1), 0);
    const dashOffset = (1 - pct) * 100;
    const hasContent = withLabel || !!children;
    return (_jsx(Base, { ...other, sx: [
            circularProgressIndicatorTheme,
            globalStyles,
            combineStyles('host'),
            sx,
        ], ref: forwardedRef, children: _jsxs("div", { ...getStyles('layer', 'progress'), role: 'progressbar', "aria-label": props['aria-label'] ?? undefined, "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, children: [_jsxs("svg", { viewBox: '0 0 4800 4800', ...getStyles('layer', 'svg'), children: [_jsx("circle", { ...getStyles('layer', 'svgCircle', 'track'), pathLength: '100' }), _jsx("circle", { ...getStyles('layer', 'svgCircle', 'activeTrack', disabled && 'activeTrack$disabled'), pathLength: '100', strokeDashoffset: dashOffset })] }), hasContent ? (_jsx("div", { ...getStyles('layer', 'label', disabled && 'label$disabled'), children: children ??
                        (labelFormatter
                            ? labelFormatter(value)
                            : `${Math.round(pct * 100)}%`) })) : null] }) }));
}));
